export const COLORS = {
  PRIMARY_LIGHT: '#b9fde2',
  PRIMARY: '#aff2d7',
  PRIMARY_DARK: '#a0e0bc',
  DUCK_EGG_BLUE: '#c1f5da',
  BACKGROUND: '#fbfbfb',
  CHARCOAL_GREY: '#3b4554',
  GREYISH_BROWN: '#4a4a4a',
  TIMBERWOLF: '#d9d8cd',
  BROWN_GREY: '#b5b5b5',
  VERY_LIGHT_PINK: '#e8e8e8',
  DARK: '#151b1f',
  DARK_SKY_BLUE: '#4a90e2',
  WHITE_FOUR: '#f8f8f8',
  BROWN_GREY_TWO: '#7c7c7c',
  LIGHT_TEAL_TWO: '#97e5c6',
}

export default {
  typography: {
    fontFamily: '"Brandon Text", sans-serif',
    color: COLORS.GREYISH_BROWN,
    fontSize: 16,
  },
  palette: {
    primary: {
      light: COLORS.PRIMARY_LIGHT,
      main: COLORS.PRIMARY,
      dark: COLORS.PRIMARY_DARK,
    },
    background: {
      default: COLORS.BACKGROUND,
    },
    text: {
      primary: COLORS.GREYISH_BROWN,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontSize: 12,
        fontWeight: 'bold',
        letterSpacing: 1,
        color: COLORS.CHARCOAL_GREY,
        '@media (max-width: 1279px)': {
          fontSize: 10,
          letterSpacing: 0.91
        }
      },
      outlined: {
        paddingTop: 8,
        paddingBottom: 8,
        borderColor: COLORS.CHARCOAL_GREY,
      },
      contained: {
        paddingTop: 9,
        paddingBottom: 9,
        paddingRight: 24,
        paddingLeft: 24,
        boxShadow: 'none',
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
      },
    },
    MuiFormLabel: {
      root: {
        color: 'rgba(74, 74, 74, 0.5)',
      },
    },
    MuiInput: {
      underline: {
        '&::before': {
          borderBottomColor: 'rgba(74, 74, 74, 0.15)',
        },
      },
    },
    PrivateSwitchBase: {
      root: {
        '& + *': {
          fontSize: 16,
          marginLeft: 4,
        },
      },
      checked: {
        '& + *': {
          fontWeight: 'bold',
        },
      },
    },
  },
}
